/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import NewsletterModel from 'cio/models/newsletter';
import { TrackedResponseMetric, TrackedResponseMetricStat } from 'cio/utils/metrics/models/tracked-response-metric';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import MetricsService from 'cio/services/metrics';
import { Entities, Periods } from 'cio/utils/metrics/common';
import { isEmpty } from '@ember/utils';

interface NewslettersResultsTrackedResponseMetricsArgs {
  newsletter: NewsletterModel;
  selectedTemplateId: string;
}

export default class NewslettersResultsTrackedResponseMetrics extends Component<NewslettersResultsTrackedResponseMetricsArgs> {
  @service metrics!: MetricsService;

  @tracked responseMetrics: TrackedResponseMetric | null = null;
  @tracked failedToLoad = false;

  fetchMetrics = task({ keepLatest: true }, async () => {
    try {
      this.responseMetrics = await this.metrics.fetchTrackedResponseMetric(
        Entities.NEWSLETTER,
        this.args.newsletter.id,
        Periods.MONTHS,
        null,
      );
    } catch {
      this.failedToLoad = true;
    }
  });

  get stat() {
    if (
      this.fetchMetrics.isRunning ||
      this.failedToLoad ||
      this.responseMetrics == null ||
      isEmpty(Object.values(this.responseMetrics.metrics))
    ) {
      return null;
    }

    if (isEmpty(this.args.selectedTemplateId)) {
      return this.consolidateMetricStats(Object.values(this.responseMetrics.metrics));
    }

    return this.responseMetrics.metrics[this.args.selectedTemplateId];
  }

  get hasStats() {
    return !isEmpty(this.stat);
  }

  private consolidateMetricStats(metrics: TrackedResponseMetricStat[]): TrackedResponseMetricStat {
    let consolidatedMetric = new TrackedResponseMetricStat({}, {});

    for (let metric of metrics) {
      consolidatedMetric.addMetric(metric);
    }

    return consolidatedMetric;
  }
}
